import { IntegrationConfigName } from '../../../../../integrations/integrations.types';
import { StatusType, SynchronizedType } from '../../../../order.types';
import {
  ForceSyncOrderStatusRule,
  IForceSyncOrderStatusRule,
} from '../force-sync-order-status-rule.interface';

export class OnApprovalForceSyncRule implements IForceSyncOrderStatusRule {
  showForceSync({
    orderStatusSync,
    integrationName,
    triggerIntegrationConfig,
  }: ForceSyncOrderStatusRule): boolean {
    const availableSyncStatus =
      orderStatusSync &&
      [
        SynchronizedType.ERROR,
        SynchronizedType.NOT_SYNCHRONIZED,
        SynchronizedType.SUCCESS_WITH_PAYMENT_ERROR,
      ].includes(orderStatusSync);

    if (!availableSyncStatus) {
      return false;
    }

    const integrationsWhichForceSync = [
      IntegrationConfigName.INTEGRADOR_LYNX_SERVER,
      IntegrationConfigName.INTEGRADOR_TOTVS_MODA,
      IntegrationConfigName.INTEGRADOR_EMILLENNIUM,
    ];

    if (integrationName && integrationsWhichForceSync.includes(integrationName)) {
      return this.validateIntegrationTrigger(triggerIntegrationConfig);
    }

    return false;
  }

  private validateIntegrationTrigger(triggerIntegrationConfig?: StatusType): boolean {
    return triggerIntegrationConfig === StatusType.ON_APPROVAL;
  }
}
